var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43.79,
    height: 44,
    rx: 21.895,
    fill: "#171717"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_345_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59616 21.8317C8.59551 24.1842 9.2102 26.4813 10.379 28.506L8.48438 35.4237L15.5638 33.5675C17.5219 34.6335 19.7158 35.192 21.9452 35.1921H21.9511C29.3108 35.1921 35.3019 29.2033 35.305 21.8422C35.3064 18.2753 33.9186 14.9211 31.3971 12.3976C28.876 9.87439 25.523 8.48405 21.9505 8.48242C14.5899 8.48242 8.59931 14.4709 8.59627 21.8317",
    fill: "url(#paint0_linear_345_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12003 21.8281C8.11927 24.2653 8.756 26.6445 9.96651 28.7417L8.00391 35.9074L15.3372 33.9847C17.3578 35.0863 19.6327 35.6671 21.9476 35.668H21.9535C29.5774 35.668 35.7836 29.4637 35.7869 21.8392C35.7882 18.144 34.3504 14.6693 31.7388 12.0554C29.1269 9.44189 25.654 8.00152 21.9535 8C14.3284 8 8.12318 14.2034 8.12014 21.8281H8.12003ZM12.4872 28.3805L12.2133 27.9459C11.0623 26.1157 10.4548 24.0007 10.4556 21.829C10.4581 15.4915 15.6158 10.3355 21.9579 10.3355C25.0292 10.3368 27.9156 11.5341 30.0866 13.7064C32.2574 15.8789 33.452 18.7668 33.4512 21.8383C33.4484 28.1757 28.2907 33.3324 21.9535 33.3324H21.949C19.8856 33.3313 17.8619 32.7772 16.097 31.73L15.677 31.4809L11.3253 32.6219L12.4872 28.3804V28.3805Z",
    fill: "url(#paint1_linear_345_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4955 16.0467C18.2365 15.4712 17.964 15.4595 17.7178 15.4494C17.5161 15.4408 17.2856 15.4414 17.0553 15.4414C16.8248 15.4414 16.4503 15.5281 16.1337 15.8738C15.8168 16.2198 14.9238 17.0559 14.9238 18.7564C14.9238 20.457 16.1624 22.1004 16.3351 22.3313C16.508 22.5617 18.7263 26.163 22.2395 27.5485C25.1593 28.6999 25.7535 28.4709 26.3872 28.4131C27.021 28.3556 28.4323 27.5772 28.7202 26.7701C29.0084 25.9631 29.0084 25.2714 28.922 25.1268C28.8356 24.9828 28.6051 24.8963 28.2594 24.7235C27.9137 24.5506 26.2143 23.7144 25.8975 23.5991C25.5806 23.4838 25.3502 23.4263 25.1197 23.7724C24.8892 24.1179 24.2273 24.8963 24.0256 25.1268C23.824 25.3579 23.6223 25.3866 23.2767 25.2137C22.9309 25.0403 21.8177 24.6758 20.497 23.4984C19.4695 22.5822 18.7758 21.4508 18.5741 21.1047C18.3725 20.7591 18.5525 20.5718 18.7259 20.3996C18.8812 20.2447 19.0716 19.996 19.2446 19.7942C19.417 19.5924 19.4745 19.4483 19.5897 19.2178C19.7051 18.9871 19.6474 18.7852 19.5611 18.6124C19.4745 18.4395 18.8028 16.7302 18.4955 16.0468",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_345_3",
    x1: 33,
    y1: 28.5,
    x2: 12.5,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_345_3",
    x1: 21.8954,
    y1: 35.9074,
    x2: 21.8954,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_345_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.79,
    height: 28,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/WHATSAPP.ad27f97d95ece8ddecac332098064211.svg";
export { ForwardRef as ReactComponent };